import React from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import { Typography } from '@guildeducationinc/recess';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import styles from './Reasons.module.scss';
interface Props {
	program: GetMemberProgramQuery['memberProgram'];
}
export const Reasons: React.FC<Props> = ({ program }) => {
	const isMobile = useIsMobile();
	const reasonsToChoose = program.studentFacingAcademicPartner.contentItems.filter(
		item => item.category === 'ABOUT'
	);

	if (!reasonsToChoose.length) {
		return null;
	}

	const reasonsToChooseList = reasonsToChoose.map(reason => (
		<li className='margin--top_8' key={`${reason.category}-${reason.title}`}>
			{reason.title && reason.title !== ' ' ? (
				<Typography variant={isMobile ? 'body1' : 'body2'}>
					<span className='fontWeight--700'>{reason.title.trim()}</span>
					{reason.body && ` - ${reason.body}`}
				</Typography>
			) : (
				<Typography variant={isMobile ? 'body1' : 'body2'}>{reason.body}</Typography>
			)}
		</li>
	));

	return (
		<section aria-label={`reasons to choose ${program.studentFacingAcademicPartner.name}`}>
			<Typography className={styles.title} variant='h3'>
				Why students choose {program.studentFacingAcademicPartner.name}
			</Typography>
			<ul className='padding--left_20'>{reasonsToChooseList}</ul>
		</section>
	);
};
